import { ELEMENT_TYPES } from 'constants/config';

const elementTypesWithHiddenContent = new Set([
  ELEMENT_TYPES.FLIPCARD,
  ELEMENT_TYPES.REVEAL,
]);

export function getContentAttribute(hit) {
  if (
    elementTypesWithHiddenContent.has(hit.element_content_type) &&
    hit._snippetResult.content.matchLevel === 'none' // eslint-disable-line
  ) {
    return 'content_hidden';
  }
  return 'content';
}
